/**
 * Reusable stateless form component for Metric
 */

// import primary libraries
import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

// import form components
import { NumberInput, TextInput } from '../../../global/components/forms';

function MetricCategoryForm({
  cancelLink
  , formTitle
  , formType
  , handleFormChange
  , handleFormSubmit
  , metricCategory
}) {

  // set the button text
  const buttonText = formType === "create" ? "Create Metric Category" : "Update Metric Category";

  // set the form header
  const header = formTitle ? <div className="formHeader"><h2> {formTitle} </h2><hr/></div> : <div/>;

  return (
    <div className="yt-container">
      <div className="yt-row center-horiz">
        <div className="form-container -slim">
          <form name="metricCategoryForm" className="metricCategory-form" onSubmit={handleFormSubmit}>
            {header}
            <TextInput
              name="title"
              label="Category"
              value={metricCategory.title}
              maxLength="150"
              change={handleFormChange}
              placeholder="Enter category here... "
              required={true}
            />
            <div className="yt-col full s_50 m_25">
              <NumberInput
                name="order"
                label="Sort order"
                helpText="Used for setting the order on the reports"
                step="1"
                value={metricCategory.order}
                change={handleFormChange}
              />
            </div>
            <div className="input-group">
              <div className="yt-row space-between">
                <Link className="yt-btn link" to={cancelLink}>Cancel</Link>
                <button className="yt-btn " type="submit" > {buttonText} </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  )
}

MetricCategoryForm.propTypes = {
  cancelLink: PropTypes.string.isRequired
  , formTitle: PropTypes.string
  , formType: PropTypes.string.isRequired
  , handleFormChange: PropTypes.func.isRequired
  , handleFormSubmit: PropTypes.func.isRequired
  , metricCategory: PropTypes.object.isRequired
}

MetricCategoryForm.defaultProps = {
  formTitle: ''
}

export default MetricCategoryForm;



// WEBPACK FOOTER //
// modules/metricCategory/components/MetricCategoryForm.js.jsx